import { render } from "./TemplateFooter.vue?vue&type=template&id=e5e42aba"
const script = {}
script.render = render

export default script